<template>
  <div class="loading-wrapper p-d-flex p-ai-center p-jc-around bg-off-white p-py-6 p-my-auto">
    <div class="p-text-center">
      <span class="pi pi-spinner pi-spin gradient-spinner"/>
      <p>Logging you out...</p>
    </div>
  </div>
</template>
<script>
import { useAccountStore } from "@/stores/account";
import { isEntraAuthActive, logoutRedirect } from "@/auth/entraAuthService";
import { isNativeAuthActive, signOutNative } from "@/auth/nativeAuthService";

export default {
  name: "Logout",
  title: "Logout",
  setup() {
    return { accountStore: useAccountStore() };
  },
  async created() {
    this.accountStore.setUser({});

    // Native sign-in never created a CIAM browser session, so a hosted end-session
    // logout lands on an empty account picker - skip it and clear the native tokens
    // from the MSAL cache. Then hand off to app-web's cookie sign-out so any app-web
    // session cookie is cleared too (during side-by-side a user may still hold a legacy
    // ADB2C cookie session); it clears the cookie and redirects to the GenTwo.com base.
    if (isNativeAuthActive()) {
      await signOutNative();
      window.location.assign("/apptwo/account/logout");
      return;
    }

    // Under the (redirect) Entra flow MSAL owns the session, so sign-out goes
    // through it rather than app-web's cookie logout.
    if (isEntraAuthActive()) {
      logoutRedirect();
      return;
    }

    window.location.href = "/apptwo/account/logout";
  },
};
</script>